module.exports = __webpack_public_path__ + "static/img/icon_nav_arr.4e0d09a3.svg";